import { render, staticRenderFns } from "./AccessSharePage.vue?vue&type=template&id=37560100"
import script from "./AccessSharePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessSharePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports